import React, { useEffect, useRef } from "react";
import LogoutButton from "../MainPage/LogoutButton";

const StudentProfile = ({ userDetail, onClose, buttonRef }) => {
    const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && profileRef.current.contains(e.target)) {
        return;
      }
      if (buttonRef && buttonRef.current && buttonRef.current.contains(e.target)) {
        return;
      }
      onClose();
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose, buttonRef]);
  
  return (
    <div
      ref={profileRef}
      className="absolute right-0 top-full w-64 bg-white border border-gray-200 rounded-lg z-50 shadow-lg"
    >
      <div className="px-3 pt-3 pb-2">
        <p className="text-sm font-medium text-blue-400 flex items-center gap-2">
          <span>👤</span>
          {userDetail?.student_email || ""}
        </p>
      </div>
      <div className="border-t border-gray-200 mx-3"></div>
      <LogoutButton />
    </div>
  );
};


export default StudentProfile;
